/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */

import { defineGame } from './fr/fr_game.js'
import { defineModal } from './fr/fr_modal.js'
import { defineOnboarding } from './fr/fr_onboarding.js'
import { defineRegister } from './fr/fr_register.js'

const i18n = {}

defineOnboarding(i18n)
defineRegister(i18n)
defineModal(i18n)

defineGame(i18n)

export default i18n
